// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { CommandRule, CommandRuleT, verifyCommandRule } from "./command-rule";
import { IgnoreRule, IgnoreRuleT, verifyIgnoreRule } from "./ignore-rule";
import { OutRule, unionToOutRule, unionListToOutRule } from "./out-rule";
import { TransformRule, TransformRuleT, verifyTransformRule } from "./transform-rule";

/**
 * An override of one control row, matched by its template's message.
 */
export class ControlOverride implements flatbuffers.IUnpackableObject<ControlOverrideT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ControlOverride {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsControlOverride(
    bb: flatbuffers.ByteBuffer,
    obj?: ControlOverride,
  ): ControlOverride {
    return (obj || new ControlOverride()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsControlOverride(
    bb: flatbuffers.ByteBuffer,
    obj?: ControlOverride,
  ): ControlOverride {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ControlOverride()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  match(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  ruleType(): OutRule {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : OutRule.NONE;
  }

  rule<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  note(): string | null;
  note(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  note(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startControlOverride(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addMatch(builder: flatbuffers.Builder, match: number) {
    builder.addFieldInt32(0, match, 0);
  }

  static addRuleType(builder: flatbuffers.Builder, ruleType: OutRule) {
    builder.addFieldInt8(1, ruleType, OutRule.NONE);
  }

  static addRule(builder: flatbuffers.Builder, ruleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, ruleOffset, 0);
  }

  static addNote(builder: flatbuffers.Builder, noteOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, noteOffset, 0);
  }

  static endControlOverride(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 8); // rule
    return offset;
  }

  static createControlOverride(
    builder: flatbuffers.Builder,
    match: number,
    ruleType: OutRule,
    ruleOffset: flatbuffers.Offset,
    noteOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ControlOverride.startControlOverride(builder);
    ControlOverride.addMatch(builder, match);
    ControlOverride.addRuleType(builder, ruleType);
    ControlOverride.addRule(builder, ruleOffset);
    ControlOverride.addNote(builder, noteOffset);
    return ControlOverride.endControlOverride(builder);
  }

  unpack(): ControlOverrideT {
    return new ControlOverrideT(
      this.match(),
      this.ruleType(),
      (() => {
        const temp = unionToOutRule(this.ruleType(), this.rule.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.note(),
    );
  }

  unpackTo(_o: ControlOverrideT): void {
    _o.match = this.match();
    _o.ruleType = this.ruleType();
    _o.rule = (() => {
      const temp = unionToOutRule(this.ruleType(), this.rule.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.note = this.note();
  }

  unpackFields(...fields: string[]): ControlOverrideT {
    const t = new ControlOverrideT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("match")) {
      t.match = this.match();
    }
    if (fieldSet.has("rule_type")) {
      t.ruleType = this.ruleType();
    }
    if (fieldSet.has("rule")) {
      t.rule = (() => {
        const temp = unionToOutRule(this.ruleType(), this.rule.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("note")) {
      t.note = this.note();
    }
    return t;
  }
}

export class ControlOverrideT implements flatbuffers.IGeneratedObject {
  constructor(
    public match: number = 0,
    public ruleType: OutRule = OutRule.NONE,
    public rule: CommandRuleT | IgnoreRuleT | TransformRuleT | null = null,
    public note: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.rule === null || this.rule === undefined) {
      throw new Error('Required field "rule" is not set');
    }
    const rule = builder.createObjectOffset(this.rule);
    const note = this.note !== null ? builder.createString(this.note!) : 0;

    return ControlOverride.createControlOverride(builder, this.match, this.ruleType, rule, note);
  }

  clone(): ControlOverrideT {
    const obj = new ControlOverrideT();
    obj.match = this.match;
    obj.ruleType = this.ruleType;
    obj.rule =
      this.rule !== null && typeof (this.rule as any).clone === "function"
        ? (this.rule as any).clone()
        : this.rule;
    obj.note = this.note;
    return obj;
  }

  equals(other: ControlOverrideT): boolean {
    if (this.match !== other.match) return false;
    if (this.ruleType !== other.ruleType) return false;
    if (this.rule !== null && other.rule !== null) {
      if (typeof (this.rule as any).equals === "function") {
        if (!(this.rule as any).equals(other.rule)) return false;
      } else if (this.rule !== other.rule) return false;
    } else if (this.rule !== other.rule) return false;
    if (this.note !== other.note) return false;
    return true;
  }
}

export function verifyControlOverride(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkUnionConsistency(tablePos, 6, 8, "rule");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 6);
        switch (uType) {
          case 1: // IgnoreRule
            {
              const o = verifier.readInt32(pos);
              verifyIgnoreRule(verifier, pos + o);
            }
            break;
          case 2: // CommandRule
            {
              const o = verifier.readInt32(pos);
              verifyCommandRule(verifier, pos + o);
            }
            break;
          case 3: // TransformRule
            {
              const o = verifier.readInt32(pos);
              verifyTransformRule(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 8, "rule");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
